/* eslint-disable */
import axios from 'axios';
import { CommonUtils } from '../common/util/CommonUtils';
import { calendarsFallbackConfig } from '../fallback_cs/calendars_config_cs';
import { CalendarActionTypesMapping } from '../common/constants/ActionTypesMapping';
import { calendarsFallbackSkuMappings } from "../fallback_cs/calendars_sku_mappings_cs";
import Logger from '../common/util/Logger';
import { DC_SERVICE_API_KEYS } from '../common/constants/CommonConstants';
import loadAPCUtil from "@sfly/uig-apc-util";

const loggerInstance = new Logger('Calendars Connector', 'Sfly-Calendar-Responsive');
export class Connector {
    constructor(dispatch) {
        const useMocks = false;
        this.commonUtils = new CommonUtils(useMocks, dispatch);
        let serviceURL = '//api2.' + this.commonUtils.getEnvPrefix() + 'shutterfly.com/v1/services-dynamic-content/v1/dynamic-content?contentSpace=';
        this.baseURL = useMocks ? '/mocks/calendars/' : serviceURL;
        this.calendarsConfigDetailsURL = this.baseURL + 'calendars_config_cs' + (useMocks ? '.json' : '');
        this.config = {
            headers: {
                'SFLY-ApiKey': this.commonUtils.getEnvPrefix() !== '' ? DC_SERVICE_API_KEYS.NON_PROD : DC_SERVICE_API_KEYS.PROD
            }
        };
    }

    /**@description
     * Method to fetch the config for calendar page /calendar?v1
     * This is the first method called.
     */
    fetchConfigDetails() {
    	return this.commonUtils.makeGetCall(this.calendarsConfigDetailsURL, 'Failed to retrive Calendars config from endpoint', this.config).then((response) => {
	    this.fetchCalendarsData(
		this.commonUtils.convertToJSON(response.data.dynamicContent, "Invalid config details received for calendars."));
    	}, (error) => {
	    this.fetchCalendarsData(calendarsFallbackConfig);
	});
    }

    /** @description
     * This method will fetch calendars specific data and update the states in store with fetched data.
    */
    fetchCalendarsData(data) {
        if(data && data.config) {
            if(data.config.calendars_sku_mappings) {
                this.fetchCalendarsPricing(this.baseURL + data.config.calendars_sku_mappings);
            } else {
                loggerInstance.warn('calendars sku mappings data not found');
                console.warn('calendars sku mappings data not found');
            }

            if (data.config.calendar_types_section_headings) {
                this.commonUtils.dispatch(CalendarActionTypesMapping["calendar_types_section_headings"].actionType(data.config.calendar_types_section_headings));
            } else {
                loggerInstance.warn('calendar types section headings data not found');
                console.warn('calendar types section headings data not found');
            }

            this.commonUtils.fetchDataInBatch(data.config.dc_batch_1, CalendarActionTypesMapping, this.baseURL);
            if(data.config.enableMagicShop) {
                setTimeout(function(){ loadAPCUtil('#apcCalendars', 'apc-calendar', "APC/Calendar"); }, 2000);
            }
        } else {
            loggerInstance.error('Looks like some JSON formatting issue in DC. Using fallback JSON.');
            console.error('Looks like some JSON formatting issue in DC. Using fallback JSON.');
            this.fetchCalendarsData(calendarsFallbackConfig);
        }
    }

    // This method will fetch the pricing and update the state pricingDetails in the store.
    async fetchCalendarsPricing(skuMappingsUrl) {

        this.commonUtils.makeGetCall(skuMappingsUrl, "calendars sku mappings not found. ", this.config)
            .then((response) => {
                if (response && response.data) {
                    let productSkuMappingDetails = this.commonUtils.getPricingRequestBody(response.data.dynamicContent);
                    if (productSkuMappingDetails)
                        this.fetchProductDisplaySummary(productSkuMappingDetails);
                    else {
                        loggerInstance.error("Looks like some JSON formatting issue in Pricing DC. Using fallback JSON.");
                        console.error("Looks like some JSON formatting issue in Pricing DC. Using fallback JSON.");
                        this.fetchProductDisplaySummary(calendarsFallbackSkuMappings);
                    }
                } else {
                    loggerInstance.error('Failed to retrieve product sku mappings data from endpoint. Using fallback mappings. ');
                    console.error('Failed to retrieve product sku mappings data from endpoint. Using fallback mappings. ');
                    this.fetchProductDisplaySummary(calendarsFallbackSkuMappings);
                }
            }, (error) => {
                loggerInstance.error(" Found Some error ",error);
                console.error(" Found Some error ",error);
                this.fetchProductDisplaySummary(calendarsFallbackSkuMappings);
            })
    }


    fetchProductDisplaySummary(productSkuMappingDetails) {
        this.commonUtils.fetchPricing(productSkuMappingDetails)
            .then((res) => {
                this.commonUtils.dispatch(CalendarActionTypesMapping["calendars_pricing_details"]
                    .actionType(this.commonUtils.getPricingDetailsObject(res.data)));
            }, (err) => {
                loggerInstance.error("unable to fetch pricing for calendars. ", err);
                console.error("unable to fetch pricing for calendars. ", err);
            });
    }
}

